import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=09dfa525&scoped=true&"
import script from "./gallery.vue?vue&type=script&lang=js&"
export * from "./gallery.vue?vue&type=script&lang=js&"
import style0 from "./gallery.vue?vue&type=style&index=0&id=09dfa525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dfa525",
  null
  
)

export default component.exports